import React, { useState, useEffect, useRef } from 'react'
import { GetPaymentToken } from '../../utility/apiClients/account/paymetricClient';
import { encryptData } from '../../utility/utils/hashing';
import OverlayLoader from '../loader/overlayLoader';
import { ToastContainer, toast } from 'react-toastify';
import styles from "../../styles/paymentBlock.module.scss";
import 'react-toastify/dist/ReactToastify.css'
import { Modal } from 'bootstrap';
import { deleteCookie } from '../../utility/utils/cookie';
import { useDispatch } from "react-redux";
import ifrstyles from "../../styles/paymentForm.module.scss";
import { useForm } from 'react-hook-form';
import Globals from "../../json/fallbackglobalvariables.json";
import Loader from '../loader';
import { PrepayNewPaymentMethodV2, PrepayExistingPaymentMethodV2 } from '../../utility/apiClients/account/prePayOTPaymentClient';
import {setBypassAccountDetailsCache} from "../../reduxStore/myAccount/accountSummarySlice";
import $ from 'jquery';
const PaymetricModal = ({isModalOpen, paymentType, setPaymentType, invoicePayAPIPayload, setInvoicePayAPIPayload, selectedZIP, iframeURLToken, totalAmount, getIframeUrl, iframeLoading, setIframeLoading, setInvoiceStatuses, setIframeURLToken, onPaymentSuccess, paymentDataProp, handleClose }) => {

  const [selectedMethod, setSelectedMethod] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const bsModal = useRef(null)
  
  const states = Globals.stateList.split(",");
  
  const handlePaymentTypeChange = async (type) => {
    setPaymentType(type);
    setError('');
    setIframeURLToken({IFrameUrl: '', AccessToken: ''})
    
    setIframeLoading(true);
    if(type === 'bank') {
      await getIframeUrl('bank');
    }else if (type === 'card') {
      await getIframeUrl('card');
    }
  };

  const modalClose = (clearData) => {

    toast.dismiss();
    setSelectedMethod("");
    setError('');
    setIsSubmitting(false);
    setPaymentType('card'); // Reset payment type 
    
    if(clearData){
      invoicePayAPIPayload.activeServiceAgreements = [];
      invoicePayAPIPayload.finalSA = [];
      totalAmount = 0;
    }
    
    // Hide the modal using Bootstrap's method
    if (bsModal.current) {
      bsModal.current.hide();
    }
    
    // Ensure cleanup after modal is hidden
    setTimeout(() => {
      const backdrop = document.querySelectorAll('.modal-backdrop');
      if (backdrop.length > 0) {
        backdrop.forEach((backdropElement) => backdropElement.remove());
      }
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
    }, 300);
    
    handleClose();
  }

  const onLoadHandler = () => {
    const $XIFrame = window.$XIFrame;
    const iFrameId = 'paymetric-iframe-id';
    const targetUrl = iframeURLToken.IFrameUrl;

    if (!$XIFrame) {
      setError('Payment system not initialized');
      setIframeLoading(false);
      return;
    }

    $XIFrame.onload({
      iFrameId: iFrameId,
      targetUrl: targetUrl,
      autosizeheight: true,
      onLoadSuccess: function () {
        setIframeLoading(false);
      },
      onError: function () {
        setIframeLoading(false);
      }
    });
  }

  const handleSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
    }

    setInvoiceStatuses({
        processing: [],
        failed: [],
        success: [],
        not_found: [],
        onqueue: [],
        pending:[]
    });
    setError('');
    
    // Get the appropriate iframe and access token based on payment type
    const iFrameId = 'paymetric-iframe-id';
    const accessToken = iframeURLToken.AccessToken;
    const targetUrl = iframeURLToken.IFrameUrl;
    
    if (!accessToken) {
      setError('Access token not available');
      return;
    }

    let billingFormZip = '';
    if($("#billingZip"))
      billingFormZip = $("#billingZip")?.val();

    const responsePacketReqZip = billingFormZip !== '' && billingFormZip?.length === 5 ? billingFormZip : selectedZIP || '00000';

    // Use $XIFrame to submit the payment form
    const $XIFrame = window.$XIFrame;
    if (!$XIFrame) {
      setError('Payment system not initialized');
      return;
    }

    $XIFrame.submit({
      iFrameId: iFrameId,
      targetUrl: targetUrl,
      onSuccess: (msg) => {
        
        setIsSubmitting(true);
        const response = JSON.parse(msg);
        
        if(!toast.isActive('paymetricInfoToast')) 
          toast.info(<Info />, { autoClose: false });

        if (response.data && response.data.HasPassed) {
          const encryptedAccessToken = encryptData(accessToken, "step2");
          GetPaymentToken(
            encryptedAccessToken, 
            invoicePayAPIPayload.customerNum, 
            totalAmount, 
            responsePacketReqZip
          ).then(tokenResponse => {
            if (tokenResponse.data.isCreditCard && tokenResponse.rawData && tokenResponse.rawData[3] && tokenResponse.rawData[3].AuthorizedCard === false) {
              setError('Card authorization failed. Please try different card details.');
              toast.dismiss({containerId: 'paymetricInfoToast'});
              toast.error("Card authorization failed. Please try different card details.", {autoClose: false});
              setIsSubmitting(false);
              return;
            }

            PrepayNewPaymentMethodV2(
              true,
              "prepay",
              tokenResponse.data,
              "MyInvoice",
              invoicePayAPIPayload.finalSA,
              tokenResponse.rawData[3]
            ).then(paymentResponse => {
                
                if (paymentResponse?.error) {
                  setError('Payment failed: ' + paymentResponse.error);
                  setIsSubmitting(false);
                  toast.dismiss({containerId: 'paymetricInfoToast'});
                  toast.error(<Error />, { autoClose: false });
                  return;
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  'event' : 'account_action',
                  'category': 'MyInvoice',
                  'action': 'payments',
                  'label': `prepay initiated - ${tokenResponse.data.isCreditCard ? 'Card' : 'Account'}`,
                  'customer_id': invoicePayAPIPayload.customerNum || '',
                  'error' : {
                    'reason' : ''
                  }});
                
                dispatch(setBypassAccountDetailsCache(true));
                toast.dismiss({containerId: 'paymetricInfoToast'});
                toast.success(<Success />, { autoClose: false });

                try {
                  // Extract paid invoice IDs
                  const paidInvoiceIds = invoicePayAPIPayload.activeServiceAgreements?.map(inv => ({ invoiceNumber: inv.invoiceNo, saNumber: inv.salesAgrNum })) || [];
                  let existingPaidInvoices = localStorage.getItem('paidInvoices') ? JSON.parse(localStorage.getItem('paidInvoices')) : [];
                  // drop stale/malformed entries that aren't {invoiceNumber, saNumber} objects
                  existingPaidInvoices = existingPaidInvoices.filter(inv => inv && typeof inv === 'object' && 'invoiceNumber' in inv);

                  // Save PaidInvoices to localStorage after payment to get actual status, deduped by value
                  localStorage.setItem('paidInvoices', JSON.stringify(Array.from(
                    new Map([...paidInvoiceIds, ...existingPaidInvoices].map(inv => [`${inv.invoiceNumber}_${inv.saNumber}`, inv])).values()
                  )));

                  // Call success callback
                  if (onPaymentSuccess) {
                    onPaymentSuccess(paidInvoiceIds);
                  }
                } catch (innerError) {
                  console.error('Error in success handler:', innerError);
                  setError('Payment succeeded but failed to update UI: ' + innerError.message);
                }
                modalClose(true);
                setIsSubmitting(false);
              })
              .catch(err => {
                console.error('Error in payment submission:', err);
                if(err?.genericMessage)
                  setError(err?.genericMessage);
                else
                  setError('Payment failed: There was an error while processing payment.');
                toast.dismiss({containerId: 'paymetricInfoToast'});
                toast.error(<Error />, { autoClose: false });
                setIsSubmitting(false);
              });
          })
            .catch(error => {
              console.error('GetPaymentToken error:', error);
              setError('Payment failed: There was an error while authorizing account details.');
              toast.dismiss({containerId: 'paymetricInfoToast'});
              toast.error("Payment failed: There was an error while authorizing account details.", {autoClose: false});
              setIsSubmitting(false);
            });
        }

        else {
          setError('Payment failed: There was an error submitting payment.');
          toast.dismiss({containerId: 'paymetricInfoToast'});
          toast.error("Payment failed:  There was an error submitting payment.", {autoClose: false});
          setIsSubmitting(false);
        }
      },
      onError: (msg) => {
        console.error('XIFrame error:', msg);
        setError('Payment failed: Server error occurred.');
        toast.error("Payment failed: Server error occurred.", {autoClose: false});
        setIsSubmitting(false);
      }
    });
  };


  const existingPaymentMethods = () => {
    setIsSubmitting(true);
    setError('');
    toast.info(<Info />, { autoClose: false });

    const selectedPaymentMethod = paymentDataProp && paymentDataProp.find(
      (m) => m.pccTokenNum === selectedMethod
    );

    PrepayExistingPaymentMethodV2(false, "prepay", selectedPaymentMethod, "MyInvoice", invoicePayAPIPayload.finalSA, "")
    .then(paymentResponse => {
        if (paymentResponse?.error) {
          setError('Payment failed: ' + paymentResponse.error);
          toast.dismiss({containerId: 'paymetricInfoToast'});
          toast.error(<Error />, { autoClose: false });
          setIsSubmitting(false);
          return;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event' : 'account_action',
          'category': 'MyInvoice',
          'action': 'payments',
          'label': `enrollment initiated - ${selectedPaymentMethod.pccCashType === 'CCD' ? 'Card' : 'Account'}`,
          'customer_id': invoicePayAPIPayload.customerNum || '',
          'error' : {
            'reason' : ''
          }});
        
        dispatch(setBypassAccountDetailsCache(true));
        
        toast.dismiss({containerId: 'paymetricInfoToast'});
        toast.success(<Success />, { autoClose: false });

        try{
          // Extract paid invoice IDs
          const paidInvoiceIds = invoicePayAPIPayload.activeServiceAgreements?.map(inv => ({ invoiceNumber: inv.invoiceNo, saNumber: inv.salesAgrNum })) || [];
          let existingPaidInvoices = localStorage.getItem('paidInvoices') ? JSON.parse(localStorage.getItem('paidInvoices')) : [];
          // drop stale/malformed entries that aren't {invoiceNumber, saNumber} objects
          existingPaidInvoices = existingPaidInvoices.filter(inv => inv && typeof inv === 'object' && 'invoiceNumber' in inv);

          // Save PaidInvoices to localStorage after payment to get actual status, deduped by value
          localStorage.setItem('paidInvoices', JSON.stringify(Array.from(
            new Map([...paidInvoiceIds, ...existingPaidInvoices].map(inv => [`${inv.invoiceNumber}_${inv.saNumber}`, inv])).values()
          )));


          // Call success callback
          if (onPaymentSuccess) {
            onPaymentSuccess(paidInvoiceIds);
          }          
        } catch (innerError) {
          console.error('Error in success handler:', innerError);
          setError('Payment succeeded but failed to update UI: ' + innerError.message);
        }
        modalClose(true);
        setIsSubmitting(false);
      })
      .catch(err => {
        console.error('Payment submission error:', err);
        if(err?.genericMessage)
          setError(err?.genericMessage);
        else
          setError('Payment failed: There was an error while processing payment.');
        toast.dismiss({containerId: 'paymetricInfoToast'});
        toast.error(<Error />, { autoClose: false });
        setIsSubmitting(false);
      });

  }

  const iFrameContRef = useRef(null);
  
  useEffect(() => {
    deleteCookie('IUcard');
    deleteCookie('IUbank');

    // Load XiSecurenet script dynamically
    const existingScript = document.querySelector(`script[src="${process.env.REACT_APP_XiSecurenet_Script_Src}"]`);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_XiSecurenet_Script_Src;
        script.async = true;
        document.body.appendChild(script);
    }

    return () => {
      // Cleanup function to remove the script if it was added
      const script = document.querySelector(`script[src="${process.env.REACT_APP_XiSecurenet_Script_Src}"]`);
      if (script) {
          document.body.removeChild(script);
      }
    };

  }, []);

  useEffect(() => {
    window.onerror = function(message, source, lineno, colno, error) {
      // Code to handle the error
      
      const errorOverlayID = "webpack-dev-server-client-overlay"
      const iframeElement = window.parent.document.querySelector("iframe#" + errorOverlayID);

      if(iframeElement && iframeElement.tagName === 'IFRAME' && iframeElement.contentWindow.document.body.textContent.includes("Script error.\nhandleError")) {
        iframeElement.parentNode.removeChild(iframeElement);
      }

      // Return true to prevent the default browser error handling (e.g., logging to console)
      // Note: returning true stops propagation in modern browsers
      return true;
    };
  }, []);
  

  useEffect(() => {
    // Create the Bootstrap modal instance
    const modalElement = document.getElementById('payMyInvoices');
    
    if(modalElement && !bsModal.current) {
      bsModal.current = new Modal(modalElement, {
        backdrop: 'static',
        keyboard: false
      });
      
      // Add event listener for when modal is fully hidden
      modalElement.addEventListener('hidden.bs.modal', () => {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('padding-right');
        const backdrops = document.querySelectorAll('.modal-backdrop');
        backdrops.forEach(backdrop => backdrop.remove());
      });
      
      bsModal.current.show();
    }

    // Cleanup function to dispose of the modal instance
    return () => {
      if (bsModal.current) {
        try {
          bsModal.current.dispose();
        } catch (e) {
          console.error('Error disposing modal:', e);
        }
        bsModal.current = null;
      }
      // Final cleanup
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('padding-right');
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());
    }

  }, [handleClose]); // Re-run if handleClose changes


  const { register, formState: { errors } } = useForm({
      mode: "onBlur",
      defaultValues: {
        address: "",
        city: "",
        state: "",
        zip: "",
      },
    });

  return (
    <>
      <ToastContainer position='bottom-right' style={{ right: "20px", zIndex: "100000" }} autoClose={false} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className={`modal modal--tutorial-prompt paymetric-modal`} aria-labelledby="myModalLabel" aria-hidden="true" data-bs-backdrop='false' tabIndex='-1' id="payMyInvoices" style={{zIndex: 99999}}>
        <div className='modal-dialog modal-dialog-centered p-0' >
          <div className={`measure-tool-model modal-content pb-20 position-relative px-16 text-center`}>
            <OverlayLoader isOpen={isSubmitting} />

            <div className="modal-header">
                <span className={`${styles["gfs-24"]} ${styles["gfw-3"]}`} id="myModalLabel">Choose a payment method</span>
                <button className="btn-close leadform-close-btn" aria-label="Close" type="button" data-bs-dismiss="modal" onClick={() => modalClose(false)}></button>
            </div>

            {paymentDataProp === null ?
             <Loader />
            :<div className={`modal-body ${styles["mob-p-16"]} px-5`} style={{ minHeight: '400px' }}>

              {paymentDataProp.map((method, index) => (
                <div className={`row ${styles["mb-16"]} ${styles["tru-mma-main-add"]}`} key={method.pccSid || index} >
                  <div className={`align-items-center gap-3 col-12 d-flex ${styles["p-16"]}`}>
                    <div>
                      <input type="radio" name="paymentMethod" value={method.pccTokenNum} checked={selectedMethod === method.pccTokenNum} 
                        onChange={(e) => setSelectedMethod(e.target.value)} className={`${styles["radio"]} mr-10`} id={`payment-method-${index}`} />
                    </div>

                    <label className={`${styles["gfs-24"]} ${styles["gfw-3"]} ${styles["glh-1"]} ${styles["m-0"]}`} htmlFor={`payment-method-${index}`} >
                      {method.pccPaymentType} ending in {method.pccAcctLast4}
                    </label>
                  </div>
                </div>
              ))}

              <div className={`row ${styles["mb-16"]} ${styles["tru-mma-main-add"]}`} >
                <div className={`align-items-center gap-2 col-12 d-flex ${styles["p-16"]}`} >
                  <div>
                    <input type="radio" name="paymentMethod" value="new" className={`${styles["radio"]} ${styles["mr-10"]}`} checked={selectedMethod === "new"}
                      onChange={async (e) => {
                        setSelectedMethod(e.target.value);
                        // Load card iframe immediately when "new" is selected
                        if (e.target.value === "new" && paymentType === 'card') {
                          setIframeLoading(true);
                          await getIframeUrl('card');
                        }
                      }}
                      id="payment-method-new" />
                  </div>

                  <label className={`${styles["gfs-24"]} ${styles["gfw-3"]} ${styles["glh-1"]} ${styles["m-0"]}`} htmlFor="payment-method-new" >
                    New payment method (Debit/Credit card or Bank account)
                  </label>
                </div>
              </div>

              {selectedMethod === "new" &&
                 <form id='PaymentForm' className={`row`} noValidate>
                  <section className='container-fluid'>
                    <div className='row'>
                      <div className={`align-items-end col d-flex ${ifrstyles["p-0"]} ${ifrstyles["paymetric--form_radio"]}`}>
                        
                        
                        <div className={`${ifrstyles["d-inline-block"]} ${ifrstyles["float-left"]} ${ifrstyles["position-relative"]}`}
                          onClick={() => handlePaymentTypeChange('card')} style={{ cursor: 'pointer', touchAction: 'manipulation' }} >
                          
                          <input type='radio' id='creditcard' value='creditcard' checked={paymentType === 'card'}  
                            style={{ display: 'none', pointerEvents: 'none'}} />
                          
                          <label htmlFor='creditcard' className={`${ifrstyles[paymentType === "card" ? "bg-white-clr" : "bg-gray-light"]} ${ifrstyles["gfs-16"]} ${ifrstyles["gfw-7"]} ${ifrstyles["glh-1"]} ${ifrstyles["m-0"]} ${ifrstyles["p-14"]}`} 
                            style={{ cursor: 'pointer', minHeight: '44px', display: 'flex', alignItems: 'center', userSelect: 'none', WebkitTapHighlightColor: 'transparent',
                              touchAction: 'manipulation', pointerEvents: 'all'}} >
                              Credit or Debit Card
                          </label>

                        </div>

                        
                        <div className={`${ifrstyles["d-inline-block"]} ${ifrstyles["float-left"]} ${ifrstyles["position-relative"]}`} onClick={() => handlePaymentTypeChange('bank')} style={{ cursor: 'pointer', touchAction: 'manipulation' }}>
                          
                          <input type='radio' id='bankaccount' value='bankaccount' checked={paymentType === 'bank'} 
                            style={{ display: 'none', pointerEvents: 'none' }} />
                          
                          <label htmlFor='bankaccount' className={`${ifrstyles[paymentType === "bank" ? "bg-white-clr" : "bg-gray-light"]} ${ifrstyles["gfs-16"]} ${ifrstyles["gfw-7"]} ${ifrstyles["glh-1"]} ${ifrstyles["m-0"]} ${ifrstyles["p-14"]}`} 
                            style={{ cursor: 'pointer', minHeight: '44px', display: 'flex', alignItems: 'center', userSelect: 'none', WebkitTapHighlightColor: 'transparent',
                              touchAction: 'manipulation', pointerEvents: 'all' }}  >
                              Bank Account
                          </label>

                        </div>
                      </div>
                    </div>

                    <div className={`${ifrstyles["paymetric--form_wrapper"]} ${ifrstyles["bg-white"]} ${ifrstyles["paymetric--mb-20"]} ${ifrstyles["py-20"]} row`}>
                      <div className='col-12 col-lg-7'>
                        <div className='row'>
                          <div className='col-12'>
                            {iframeLoading ? <Loader height="30vh" />
                            : <iframe
                                src={iframeURLToken.IFrameUrl}
                                id={'paymetric-iframe-id'}
                                className='payment-iframe w-100'
                                onLoad = {onLoadHandler}
                                title="Payment Iframe"
                                ref={iFrameContRef}
                              />
                            }
                          </div>

                          
                          {paymentType === 'card' && (
                            <div className='col-12'>
                              <div className={ifrstyles["paymetric--form"]}>
                                <div className={`${ifrstyles["paymetric--mb-20"]} row`}>
                                  <div className='col'>
                                    <input 
                                      placeholder="Billing Address"
                                      {...register("address")}
                                      className={`${ifrstyles["form-control"]}`}
                                      id='billingAddress'
                                      aria-describedby='billingAddress'
                                    />
                                  </div>
                                </div>
                                
                                <div className='row'>
                                  <div className={`col-12 col-md ${ifrstyles["paymetric--mb-20"]} ${ifrstyles["mb-md-0"]}`}>
                                    <input 
                                      placeholder="City"
                                      {...register("city")}
                                      className={`${ifrstyles["form-control"]}`}
                                      id='billingCity'
                                      aria-describedby='billingCity'
                                    />
                                  </div>
                                  
                                  <div className={`col-12 col-md ${ifrstyles["paymetric--mb-20"]} ${ifrstyles["mb-md-0"]}`}>
                                    
                                    <select
                                      {...register("state")}
                                      className={`${ifrstyles["form-control"]} rounded-0 mt-0`}
                                      id='billingState'
                                    >
                                      <option value="">State</option>
                                      {states.map((s) => (
                                        <option key={s} value={s}>
                                          {s}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                  
                                  <div className={`col-12 col-md ${ifrstyles["paymetric--mb-20"]} ${ifrstyles["mb-md-0"]}`}>
                                    <input 
                                      placeholder="Zip Code"
                                      {...register("zip", {
                                        pattern: {
                                          value: /^\d{5}(-\d{4})?$/,
                                          message: "Invalid zip",
                                        },
                                      })}
                                      className={`${ifrstyles["form-control"]}`}
                                      id='billingZip'
                                      aria-describedby='billingZip'
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
              
                      <div className='col-12 col-lg-5'>
                        <div className={paymentType === 'card' ? 'd-block' : 'd-none'}>
                          <div className={`col-12 ${ifrstyles["g-font-italic"]} ${ifrstyles["gfs-14"]} ${ifrstyles["gfw-3"]} ${ifrstyles["paymetric--mb-20"]}`}>
                            TruGreen accepts the following cards
                          </div>
                          <div className='col-12'>
                            <div className={`${ifrstyles["form-row"]} ${ifrstyles["paymetric--mb-20"]} d-flex align-items-center`}>
                              <div className={`col mcIndicator ${ifrstyles["paymetric--form_card"]} ${ifrstyles["paymetric--form_card-sm"]}`} >
                                <img src="/images/myAccount/paymentForm/MasterCard_lg.png" alt="Mastercard" className='img-fluid' loading="lazy" />
                              </div>
                              <div className={`col ${ifrstyles["paymetric--form_card"]} ${ifrstyles["paymetric--form_card-sm"]} viIndicator`}>
                                <img src="/images/myAccount/paymentForm/Visa_lg.png" alt="Visa" className='img-fluid' loading="lazy" />
                              </div>
                              <div className={`axIndicator col ${ifrstyles["paymetric--form_card"]} ${ifrstyles["paymetric--form_card-sm"]}`}>
                                <img src="/images/myAccount/paymentForm/AmericanExpress_lg.png" alt="American Express" className='img-fluid' loading="lazy" />
                              </div>
                              <div className={`col ${ifrstyles["paymetric--form_card"]} ${ifrstyles["paymetric--form_card-sm"]} diIndicator`}>
                                <img src="/images/myAccount/paymentForm/Discover_lg.png" alt="Discover" className='img-fluid' loading="lazy" />
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div className={paymentType === 'bank' ? 'd-block' : 'd-none'}>
                          <div className='col-12 text-center'>
                            <img src='/images/myAccount/CheckSample.png' className='img-fluid' alt="Check Sample" />
                          </div>
                        </div>
                      </div>
                    </div>

                  </section>

                  <div id='paymetricSubmitCancel' className='row'>
                    <div className={`col-12 p-0 d-flex justify-content-center gap-3 ${styles["mob-btn-width"]}`}>
                      <div className="text-right">
                        <button onClick={() => modalClose(false)} data-bs-dismiss="modal" aria-label="Close" type='button' className={`btn ${styles["btn-gray-light"]} ${styles["btn-lg"]} ${styles["mb-20"]} ${styles["mb-md-0"]} ${styles["text-white"]} ${styles["w-100"]}`} >
                          Cancel
                        </button>
                      </div>

                      <div className='text-right'>
                        <button type="button" className={`btn ${styles["btn-lg"]} ${ifrstyles["btn-primary"]} ${ifrstyles["btn-orange"]} mb-10 ml-10`} onClick={handleSubmit} disabled={selectedMethod === "" || isSubmitting} >
                          {isSubmitting ? 'Processing...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              }

              {selectedMethod !== "new" && (
                <div className="row">
                  <div className={`${styles["mob-p-16"]} col-12 p-0`}>
                    <div className="justify-content-end row">
                      <div className="col-12 col-md-6 col-lg-6 col-xl-4 text-right">
                        <button onClick={() => modalClose(false)} data-bs-dismiss="modal" aria-label="Close" type='button' className={`btn ${styles["btn-gray-light"]} ${styles["btn-lg"]} ${styles["mb-20"]} ${styles["mb-md-0"]} ${styles["text-white"]} ${styles["w-100"]}`} >Cancel</button>
                      </div>
                      
                      <div className="col-12 col-md-6 col-lg-6 col-xl-4 text-right">
                        <button type="submit" className={`btn ${styles["btn-lg"]} ${styles["btn-primary"]} ${styles["w-100"]} ${selectedMethod === "" ? "disabled" : "" }`} disabled={selectedMethod === "" || isSubmitting} onClick={existingPaymentMethods} >
                          {isSubmitting ? 'Processing...' : 'Submit'}
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              )}
            </div>
            }
          </div>
        </div>
      </div>
    </>
  )
}


const Success = () => {
  return <div>
    <h6 style={{fontWeight: 700, fontSize: "14px"}}>Payment submitted.</h6>
    <p style={{fontSize: "12px"}}>Your payment has been successfully submitted. A confirmation will be sent shortly.</p>
  </div>
}

const Error = () => {
  return <div>
    <h6 style={{fontWeight: 700, fontSize: "14px"}}>We couldn&apos;t complete your payment.</h6>
    <p style={{fontSize: "12px"}}>No charges were made. Please try again or contact us for assistance.</p>
  </div>
}

const Info = () => {
  return <div id='paymetricInfoToast'>
    <h6 style={{fontWeight: 700, fontSize: "14px"}}>Processing your payment...</h6>
    <p style={{fontSize: "12px"}}>Please wait while we submit your payment. This may take a few moments.</p>
  </div>
}

export default PaymetricModal;